export const SPACE_XXS = '2px';
export const SPACE_XS = '4px';
export const SPACE_S = '8px';
export const SPACE_M = '16px';
export const SPACE_L = '32px';
export const SPACE_XL = '64px';
